import { render, staticRenderFns } from "./login-page.vue?vue&type=template&id=4ced8242"
import script from "./login-page.vue?vue&type=script&lang=js"
export * from "./login-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ced8242')) {
      api.createRecord('4ced8242', component.options)
    } else {
      api.reload('4ced8242', component.options)
    }
    module.hot.accept("./login-page.vue?vue&type=template&id=4ced8242", function () {
      api.rerender('4ced8242', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/shared/components/general/login-page.vue"
export default component.exports